import { useState, useEffect } from "react"
import { useUpdateFinalQuestionSetMutation, useDeleteFinalQuestionSetMutation } from "./questionSetsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCopy, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"

import 'react-quill/dist/quill.snow.css'; // import the styles
import Questions from "./partial/Questions"
import TimeLeft from "../../partial/TimeLeft"

const EditFinalQuestionSetForm = ({ finalQuestionSet }) => {
    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateFinalQuestionSet, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateFinalQuestionSetMutation()

    const [deleteFinalQuestionSet, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteFinalQuestionSetMutation()

    const navigate = useNavigate()

    const [active, setActive] = useState(finalQuestionSet.active)
    const [incluedInGrade, setIncluedInGrade] = useState(finalQuestionSet.incluedInGrade)
    const [allowBack, setAllowBack] = useState(finalQuestionSet.allowBack)
    const [ratio, setRatio] = useState(finalQuestionSet.ratio)
    const [showResults, setShowResults] = useState(finalQuestionSet.showResults)
    const [fromDate, setFromDate] = useState(new Date(finalQuestionSet.fromDate))
    const [toDate, setToDate] = useState(new Date(finalQuestionSet.toDate))
  



    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            navigate(`/${type}/${groupId}/question-sets/${finalQuestionSet.questionSet}/final`);
        }

    }, [isSuccess, isDelSuccess, navigate])

  
    const canSave =[fromDate, toDate].every(Boolean) && !isLoading;

    const onSaveFinalQuestionSetClicked = async (e) => {
        if (canSave) {
            await updateFinalQuestionSet({
                id:finalQuestionSet._id,
                fromDate,
                toDate,
                active,
                allowBack,
                showResults,
                ratio,
                incluedInGrade
              })
        }
    }

    const onDeleteFinalQuestionSetClicked = async () => {
      if(window.confirm('are you sure')){
        await deleteFinalQuestionSet({ finalQuestionSetId: finalQuestionSet._id })
      }
    }

   


    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''




    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit FinalQuestionSet</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to FinalQuestionSet"
                            onClick={()=>{navigate(`/${type}/${groupId}/question-sets/${finalQuestionSet.questionSet}/final`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>              
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveFinalQuestionSetClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteFinalQuestionSetClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
                    </div>
                </div>

                <div className='grid-results'>
        <span className='grid-results-header'>#</span>
        <span className='grid-results-data'>{finalQuestionSet._id}</span>
        <span className='grid-results-header'>כותרת</span>
        <span className='grid-results-data'>{finalQuestionSet?.title}</span>
        <span className='grid-results-header'>קבוצה</span>
        <span className='grid-results-data'>{finalQuestionSet?.group?.name}</span>
        <span className='grid-results-header'>מס' תלמידים </span>
        <span className='grid-results-data'>{finalQuestionSet?.numUsers}</span>


        </div>
               
                <div className="form-input-container">

                
                <div className="form-input-container">
                 <label className="form__label" htmlFor="fromDate">
                    From Date:</label>
                    <input
                    className={`form__input  ${!fromDate &&'form__input--incomplete'}`}
                    id="fromDate"
                    name="fromDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${fromDate.getFullYear().toString()}-${(fromDate.getMonth() + 1).toString().padStart(2, 0)}-${fromDate.getDate().toString().padStart(2, 0)}T${fromDate.getHours().toString().padStart(2, 0)}:${fromDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setFromDate(new Date(e.target.value))}
                />
                </div>
                 <div className="form-input-container">
                 <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>
               
              
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-include-in-grade">
                    Inclued In Grade:
                    <input
                        className="form__checkbox"
                        id="user-include-in-grade"
                        name="user-include-in-grade"
                        type="checkbox"
                        checked={incluedInGrade}
                        onChange={(e)=>setIncluedInGrade(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-allowBack">
                    ALLOW BACK:
                    <input
                        className="form__checkbox"
                        id="user-allowBack"
                        name="user-allowBack"
                        type="checkbox"
                        checked={allowBack}
                        onChange={(e)=>setAllowBack(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-showResults">
                    SHOW RESULTS:
                    <input
                        className="form__checkbox"
                        id="user-showResults"
                        name="user-showResults"
                        type="checkbox"
                        checked={showResults}
                        onChange={(e)=>setShowResults(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
      





 
        <Questions  questions={finalQuestionSet.questions} readOnly={true} setQuestions={()=>{}} />
               
        </form>
           
          
        </>
    )

    return content
}

export default EditFinalQuestionSetForm